module.exports = __webpack_public_path__ + "media/application/images/perish/title-2000-e57fe9334c71f529fb56d71f7a8a8645.png";